import type { ClientItemId } from 'owa-client-ids';
import { shouldShowAttachmentPreviewsForConversation } from 'owa-mail-attachment-previews';
import type { TableView } from 'owa-mail-list-store';
import { TableQueryType } from 'owa-mail-list-store';
import type ConversationItem from 'owa-mail-list-store/lib/store/schema/ConversationItem';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import type { ConversationType } from 'owa-graph-schema';
import type BaseItemId from 'owa-service/lib/contract/BaseItemId';
import type ItemId from 'owa-service/lib/contract/ItemId';
import { lazyGetConversationClientIdForSearchResult } from 'owa-mail-search/lib/lazyFunctions';
import { getUserConfiguration } from 'owa-session-store';
import getShouldShowTxpForRowAndPrepareTxpItem from 'owa-listview-txp/lib/utils/getShouldShowTxpForRowAndPrepareTxpItem';

function mapBaseItemIdsToItemIds(baseItemIds: BaseItemId[]): string[] {
    const itemIds: string[] = [];
    for (const baseItemId of baseItemIds) {
        const itemId: ItemId = <ItemId>{ ...baseItemId };
        itemIds.push(itemId.Id);
    }
    return itemIds;
}

//TODO: 22724 itemId should be ClientItemId so we don't need this function to get mailboxInfo
function getConversationClientId(
    conversationType: ConversationType,
    tableView: TableView
): ClientItemId {
    if (tableView?.tableQuery?.type == TableQueryType.Search) {
        const getConversationClientIdForSearchResult = lazyGetConversationClientIdForSearchResult.tryImportForRender();
        if (getConversationClientIdForSearchResult) {
            return getConversationClientIdForSearchResult(conversationType, tableView);
        }
    }

    return {
        Id: conversationType.ConversationId.Id,
        mailboxInfo: getMailboxInfo(tableView),
    };
}

export default function mapConversationTypeToConversationItem(
    conversationType: ConversationType,
    tableView: TableView
): ConversationItem {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2345 (37,45): Argument of type 'Maybe<BaseItemId[]> | undefined' is not assignable to parameter of type 'BaseItemId[]'.
    // @ts-expect-error
    const itemIds = mapBaseItemIdsToItemIds(conversationType.GlobalItemIds);
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2533 (41,27): Object is possibly 'null' or 'undefined'.
    // @ts-expect-error
    const latestItemId = (conversationType.ItemIds[0] as ItemId).Id;
    const conversationItem: ConversationItem = {
        id: conversationType.ConversationId.Id,
        subject: conversationType.ConversationTopic,
        globalItemIds: itemIds,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (49,9): Type 'boolean | undefined' is not assignable to type 'boolean'.
        // @ts-expect-error
        shouldShowAttachmentPreviews:
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2532 (53,13): Object is possibly 'undefined'.
            // @ts-expect-error
            getUserConfiguration().UserOptions.ShowInlinePreviews &&
            shouldShowAttachmentPreviewsForConversation(conversationType, tableView.tableQuery),
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (62,9): Type 'Maybe<number> | undefined' is not assignable to type 'number'.
        // @ts-expect-error
        globalUnreadCount: conversationType.GlobalUnreadCount,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (66,9): Type 'Maybe<number> | undefined' is not assignable to type 'number'.
        // @ts-expect-error
        size: conversationType.Size,
        clientId: getConversationClientId(conversationType, tableView),
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (71,9): Type 'Maybe<number> | undefined' is not assignable to type 'number'.
        // @ts-expect-error
        globalMessageCount: conversationType.GlobalMessageCount,
        shouldShowTxpButton: getShouldShowTxpForRowAndPrepareTxpItem(
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2345 (76,13): Argument of type 'Maybe<number> | undefined' is not assignable to parameter of type 'number'.
            // @ts-expect-error
            conversationType.EntityNamesMap,
            conversationType.InstanceKey,
            latestItemId,
            tableView
        ),
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (84,9): Type 'Maybe<boolean> | undefined' is not assignable to type 'boolean | undefined'.
        // @ts-expect-error
        hasExternalEmails: conversationType.HasExternalEmails,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (88,9): Type 'boolean | null | undefined' is not assignable to type 'boolean'.
        // @ts-expect-error
        hasSharepointLink: conversationType.HasProcessedSharepointLink,
    };

    return conversationItem;
}
